document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const searchButton = document.querySelector('[data-search-toggle]');
  const searchDrawer = document.querySelector('[data-search-drawer]');

  const closeAll = () => {
    mobileMenu?.removeAttribute('open');
    searchDrawer?.removeAttribute('open');
    document.body.classList.remove('drawer-open');
    menuButton?.setAttribute('aria-expanded', 'false');
    searchButton?.setAttribute('aria-expanded', 'false');
  };

  menuButton?.addEventListener('click', () => {
    const isOpen = mobileMenu?.hasAttribute('open');
    closeAll();
    if (!isOpen) {
      mobileMenu?.setAttribute('open', '');
      menuButton.setAttribute('aria-expanded', 'true');
    }
  });

  searchButton?.addEventListener('click', () => {
    const isOpen = searchDrawer?.hasAttribute('open');
    closeAll();
    if (!isOpen) {
      searchDrawer?.setAttribute('open', '');
      searchButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
      searchDrawer?.querySelector('input[type="search"]')?.focus();
    }
  });

  document.querySelectorAll('[data-close-drawer]').forEach((button) => {
    button.addEventListener('click', closeAll);
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.product-main-image');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.imageUrl;
        mainImage.srcset = '';
        mainImage.alt = button.dataset.imageAlt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.remove('active'));
        button.classList.add('active');
      });
    });
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value) - Number(input.step || 1));
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value) + Number(input.step || 1);
    });
  });

  document.querySelectorAll('[data-variant-options]').forEach((options) => {
    const form = options.closest('form');
    const details = options.closest('.product-details');
    const variantInput = form?.querySelector('[data-variant-id]');
    const variantsElement = form?.querySelector('[data-product-variants]');
    const addButton = form?.querySelector('button[name="add"]');
    const price = details?.querySelector('[data-product-price]');
    const packageTotal = details?.querySelector('[data-package-total]');
    const packageLabel = details?.querySelector('[data-package-label]');
    const unitPrice = details?.querySelector('[data-unit-price]');
    if (!variantInput || !variantsElement || !addButton) return;

    const variants = JSON.parse(variantsElement.textContent);
    const selects = [...options.querySelectorAll('[data-option-position]')];
    const updateVariant = () => {
      const selectedOptions = selects.map((select) => select.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]));
      if (!variant) {
        addButton.disabled = true;
        return;
      }
      variantInput.value = variant.id;
      addButton.disabled = !variant.available;
      if (price) price.textContent = variant.price;
      if (packageTotal) packageTotal.textContent = variant.price;
      if (packageLabel) packageLabel.textContent = variant.packageLabel;
      if (unitPrice) unitPrice.textContent = variant.unitPrice || '';
    };

    selects.forEach((select) => select.addEventListener('change', updateVariant));
    updateVariant();
  });

  document.querySelectorAll('.product-form').forEach((form) => {
    const referencePhoto = form.querySelector('[data-reference-photo]');
    if (!referencePhoto) return;
    const referencePhotoSlots = [referencePhoto, ...form.querySelectorAll('[data-reference-photo-slot]')];
    const uploadName = form.querySelector('[data-upload-name]');
    const uploadPreviews = form.querySelector('[data-upload-previews]');
    const uploadLimit = form.querySelector('[data-upload-limit]');
    const formAlert = form.querySelector('[data-product-form-alert]');
    const personalizationInput = form.querySelector('[data-personalization-input]');
    const personalizationField = form.querySelector('[data-personalization-field]');
    const textPreferenceInputs = [...form.querySelectorAll('input[name="properties[Text preference]"]')];
    const photoPreferenceInputs = [...form.querySelectorAll('input[name="properties[Reference photo delivery]"]')];
    const photoUploadGroup = form.querySelector('[data-photo-upload-group]');
    const maxReferencePhotos = Number(referencePhoto.dataset.maxFiles || 5);
    let referenceFiles = [];
    let previewUrls = [];

    const renderReferencePhotos = () => {
      previewUrls.forEach((url) => URL.revokeObjectURL(url));
      previewUrls = [];
      if (uploadName) {
        uploadName.textContent = referenceFiles.length
          ? uploadName.dataset.selectedTemplate.replace('__count__', String(referenceFiles.length))
          : uploadName.dataset.emptyName;
      }
      if (!uploadPreviews) return;
      uploadPreviews.replaceChildren();
      referenceFiles.forEach((file, index) => {
        const previewUrl = URL.createObjectURL(file);
        previewUrls.push(previewUrl);
        const preview = document.createElement('figure');
        preview.className = 'upload-preview';
        const image = document.createElement('img');
        image.src = previewUrl;
        image.alt = file.name;
        const caption = document.createElement('figcaption');
        caption.textContent = file.name;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'upload-preview__remove';
        remove.textContent = referencePhoto.dataset.removeLabel;
        remove.setAttribute('aria-label', `${referencePhoto.dataset.removeLabel}: ${file.name}`);
        remove.addEventListener('click', () => {
          referenceFiles.splice(index, 1);
          syncReferencePhotos();
        });
        preview.append(image, caption, remove);
        uploadPreviews.append(preview);
      });
    };

    const syncReferencePhotos = () => {
      referencePhotoSlots.forEach((slot, index) => {
        const transfer = new DataTransfer();
        if (referenceFiles[index]) transfer.items.add(referenceFiles[index]);
        slot.files = transfer.files;
      });
      renderReferencePhotos();
    };

    const selectedValue = (inputs) => inputs.find((input) => input.checked)?.value || '';
    const syncPreferences = () => {
      const wantsText = selectedValue(textPreferenceInputs) === 'Add personalized text';
      if (personalizationInput) {
        personalizationInput.disabled = !wantsText;
        personalizationInput.setAttribute('aria-required', String(wantsText));
        personalizationInput.removeAttribute('aria-invalid');
        if (!wantsText) personalizationInput.value = '';
      }
      if (personalizationField) personalizationField.hidden = !wantsText;

      const uploadsNow = selectedValue(photoPreferenceInputs) === 'Upload now';
      if (photoUploadGroup) photoUploadGroup.hidden = !uploadsNow;
      referencePhotoSlots.forEach((slot) => { slot.disabled = !uploadsNow; });
      if (!uploadsNow) {
        referenceFiles = [];
        syncReferencePhotos();
      }
      if (formAlert) formAlert.hidden = true;
    };

    referencePhoto.addEventListener('change', (event) => {
      const incomingFiles = [...event.target.files];
      const combinedFiles = [...referenceFiles, ...incomingFiles].filter((file, index, files) => (
        files.findIndex((candidate) => candidate.name === file.name && candidate.size === file.size && candidate.lastModified === file.lastModified) === index
      ));
      const exceedsLimit = combinedFiles.length > maxReferencePhotos;
      referenceFiles = combinedFiles.slice(0, maxReferencePhotos);
      if (uploadLimit) uploadLimit.hidden = !exceedsLimit;
      syncReferencePhotos();
    });

    [...textPreferenceInputs, ...photoPreferenceInputs].forEach((input) => {
      input.addEventListener('change', syncPreferences);
    });

    form.addEventListener('submit', (event) => {
      const errors = [];
      const wantsText = selectedValue(textPreferenceInputs) === 'Add personalized text';
      const uploadsNow = selectedValue(photoPreferenceInputs) === 'Upload now';
      if (wantsText && !personalizationInput?.value.trim()) {
        errors.push(formAlert?.dataset.textRequiredMessage || 'Add your personalization details.');
        personalizationInput?.setAttribute('aria-invalid', 'true');
      }
      if (uploadsNow && referenceFiles.length === 0) {
        errors.push(formAlert?.dataset.photoRequiredMessage || 'Upload at least one reference image.');
        referencePhoto.setAttribute('aria-invalid', 'true');
      }
      if (errors.length === 0) return;
      event.preventDefault();
      if (formAlert) {
        formAlert.innerHTML = `<strong>${formAlert.dataset.errorTitle}</strong><ul>${errors.map((error) => `<li>${error}</li>`).join('')}</ul>`;
        formAlert.hidden = false;
        formAlert.focus();
      }
    });

    syncPreferences();
  });

  document.querySelectorAll('[data-shop-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[data-shop-tab]');
    const shopShell = tabs.closest('.page-shell');
    const cards = shopShell?.querySelectorAll('[data-product-card]') || [];
    const emptyState = shopShell?.querySelector('[data-shop-empty]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((tab) => {
          const isActive = tab === button;
          tab.classList.toggle('active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
        });
        let visibleCount = 0;
        cards.forEach((card) => {
          const categories = (card.dataset.categories || '').split(/\s+/);
          const isVisible = button.dataset.filter === 'all' || categories.includes(button.dataset.filter);
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });
        if (emptyState) emptyState.hidden = visibleCount > 0;
      });
    });
    (tabs.querySelector('[data-shop-tab].active') || buttons[0])?.click();
  });
});
